import React, { useRef } from "react";

// Native <input type="date"> renders in the browser/OS locale (often MM/DD/YYYY),
// which led HR to read "10/04/2026" as 10 April instead of 4 October. We keep the
// native picker (and the ISO yyyy-mm-dd value) but show the date as DD/MM/YYYY.
const isoToDMY = (v) => {
  const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(v || "");
  return m ? `${m[3]}/${m[2]}/${m[1]}` : "";
};

const DateField = ({ placeholder, value, onChange, style: st, bg, error }) => {
  const ref = useRef(null);
  const open = () => { try { ref.current?.showPicker?.(); } catch { /* picker needs a user gesture */ } };
  return (
    <div className="relative" style={st}>
      <div className={`w-full py-[7px] px-[10px] ${bg || "bg-bg2"} border ${error ? "border-r" : "border-b0"} rounded-[10px] text-[14px] pr-[34px] ${value ? "text-t0" : "text-t3"}`}>
        {isoToDMY(value) || placeholder || "DD/MM/YYYY"}
      </div>
      <svg className="absolute right-[10px] top-1/2 -translate-y-1/2 text-t3 pointer-events-none" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="3" y="4" width="18" height="18" rx="2" /><path d="M16 2v4M8 2v4M3 10h18" /></svg>
      <input
        ref={ref}
        type="date"
        value={value || ""}
        onClick={open}
        onChange={e => onChange?.(e.target.value)}
        className="absolute inset-0 w-full h-full opacity-0 cursor-pointer"
      />
    </div>
  );
};

export const Inp = ({ icon: Ic, placeholder, value, onChange, style: st, type, bg, error, maxLength }) =>
  type === "date"
    ? <DateField placeholder={placeholder} value={value} onChange={onChange} style={st} bg={bg} error={error} />
    : <div className="relative" style={st}>
    {Ic && <Ic size={13} className="absolute left-[10px] top-1/2 -translate-y-1/2 text-t3 pointer-events-none" />}
    <input
      type={type || "text"}
      placeholder={placeholder}
      value={value}
      maxLength={maxLength}
      onChange={e => onChange?.(e.target.value)}
      className={`w-full py-[7px] pr-[10px] ${bg || "bg-bg2"} border ${error ? "border-r" : "border-b0"} rounded-[10px] text-t0 text-[14px] outline-none ${Ic ? "pl-[32px]" : "pl-[10px]"}`}
    />
  </div>;
